import MenuFrame from "../frames/menu_frame";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement } from 'chart.js';
import { useState } from "react";
import { ReportNav } from "./nav";
import { getFinData, getOptions, groupCashNoteData, makeGraph } from "./reports_halper";
import { Box, Grid } from "@mui/material";
import { Bar } from "react-chartjs-2";


function FinReportViewer() {
    const [deskData, setDeskData] = useState(null);
    ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend);

    const initData = async (auth) => {
        if (!auth) return;
        setDeskData(await getFinData());
    }

    const makeMonthGraphCashNote = (data) => {
        if (data === null) return [];
        data = groupCashNoteData(data, ["Sales", "Purchase", "Contra", "Purchase Return", "Refund", "GST", "Salary", "Rent", "Transport Expanse", "Booking"]);
        return makeGraph(data.span, [data.purchase, data["transport expanse"], data.rent], ["Sales", "Purchase", "Contra", "Purchase Return", "Refund", "GST", "Salary", "Rent", "Transport Expanse", "Booking"]);
    }

    const makeGraphInvoiceM = (data) => {
        if (data === null) return [];
        const label = data.map((itm) => itm.month_year);
        const amount = data.map((itm) => itm.amount);
        const due = data.map((itm) => itm.due_amount);
        return makeGraph(label, [amount, due], ['Invoice Amount', 'Due']);
    }

    const makeGraphInvoiceC = (data) => {
        if (data === null) return [];
        const label = data.map((itm) => itm.name);
        const amount = data.map((itm) => itm.amount);
        const due = data.map((itm) => itm.due_amount);
        return makeGraph(label, [amount, due], ['Invoice Amount', 'Due']);
    }

    return (
        <MenuFrame permission="ORG_REPORT" screen="FIN_REPORT" onInit={initData}>
            <ReportNav active="finance" />

            <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Box sx={{ height: 300 }}>
                        <Bar data={makeMonthGraphCashNote(deskData?.cash ?? null)} options={getOptions("Cash note issued - Monthly", false, false)} />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Box sx={{ height: 300 }}>
                        <Bar data={makeGraphInvoiceM(deskData?.invoice_monthly ?? null)} options={getOptions("Invoice Issued - Monthly", false, false)} />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <Box sx={{ height: 600 }}>
                        <Bar data={makeGraphInvoiceC(deskData?.invoice_client ?? null)} options={getOptions("Invoice Issued - Client Wise", true, false)} />
                    </Box>
                </Grid>
            </Grid>
        </MenuFrame>
    );
}

export default FinReportViewer;
